import { ApiError, OldApiResult } from '@models/api';
import { UseQueryOptions, useQuery } from '@hooks/react-query';

import { checkGrabModalFeature } from 'new-services/authService';
import { FeatureSettingsResponse } from '../models';

function useRGetFeatureSettings(
  options: UseQueryOptions<
    OldApiResult<FeatureSettingsResponse>,
    ApiError
  > = {},
) {
  return useQuery<OldApiResult<FeatureSettingsResponse>, ApiError>({
    queryKey: ['feature-settings'],
    queryFn: checkGrabModalFeature,
    ...options,
  });
}

export default useRGetFeatureSettings;
